import { SimpleGrid } from '@mantine/core';

import classes from './simple-grid.module.css';
export const SimpleGridOverride = SimpleGrid.extend({ classNames: classes });
